function renderIconicBenefitsSecond(component) {
  if (!component) {
    console.warn('Benefit component not found');
    return;
  }
  
  // Clear existing content before re-rendering
  component.innerHTML = "";
  
  let settings;
  try {
    settings = JSON.parse(component.dataset.settings);
  } catch (e) {
    console.error('Error parsing benefit settings:', e);
    return;
  }
  
  // Check if benefit box is enabled
  if (!settings.enable_benefit_box) {
    console.log('Benefit box is disabled in settings');
    component.style.display = "none";
    return;
  }
  
  const blockId = component.dataset.blockId;
  
  // Ensure component is visible with important styles
  component.style.display = "block";
  component.style.opacity = "1";
  component.style.visibility = "visible";
  component.style.margin = "20px 0";
  
  // Create wrapper with responsive grid
  const wrapper = document.createElement("div");
  wrapper.className = `iconic-benefits-second-wrapper-${blockId}`;
  wrapper.style.cssText = `
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px;
    margin-top: 12px;
    margin-bottom: 12px;
    word-break: break-word;
    width: 100%;
  `;
  
  // Add media query for desktop
  const style = document.createElement('style');
  style.textContent = `
    @media (min-width: 768px) {
      .iconic-benefits-second-wrapper-${blockId} {
        grid-template-columns: repeat(2, 1fr) !important;
        gap: 16px !important;
      }
    }
  `;
  document.head.appendChild(style);
  
  function createBenefitBox(index) {
    const text = settings[`benefit_text_${index}`];
    const subtext = settings[`benefit_subtext_${index}`];
    const iconImage = settings[`benefit_icon_image_${index}`];
    const iconClass = settings[`icon_text_${index}`];
    
    // Skip if no text content
    if (!text && !subtext) return null;
    
    const boxDiv = document.createElement("div");
    boxDiv.style.cssText = `
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
      background-color: ${settings.benefit_box_color || "#F5F6F7"};
      border-radius: ${settings.benefit_box_radius || 10}px;
      padding: 16px;
      width: 100%;
      box-sizing: border-box;
    `;
    
    const contentDiv = document.createElement("div");
    const alignment = settings.text_alignment || "start";
    contentDiv.style.cssText = `
      display: flex;
      flex-direction: column;
      gap: 8px;
      width: 100%;
      align-items: ${alignment === "start" ? "flex-start" : alignment === "end" ? "flex-end" : "center"};
      text-align: ${alignment};
    `;

    // Add icon (image or class)
    if (iconImage) {
      const imgWrapper = document.createElement("div");
      const iconSize = settings.benefit_icon_size || 24;
      imgWrapper.style.cssText = `
        display: inline-block;
        width: ${iconSize}px;
        min-width: ${iconSize}px;
        height: ${iconSize}px;
        line-height: ${iconSize}px;
        margin-bottom: 4px;
      `;
      
      const img = document.createElement("img");
      img.src = iconImage;
      img.loading = "lazy";
      img.alt = text || `Benefit ${index}`;
      img.style.cssText = `
        width: 100%;
        height: 100%;
        object-fit: contain;
      `;
      
      imgWrapper.appendChild(img);
      contentDiv.appendChild(imgWrapper);
    } else if (iconClass) {
      const iconWrapper = document.createElement("div");
      const iconSize = settings.benefit_icon_size || 24;
      iconWrapper.style.cssText = `
        font-size: ${iconSize}px;
        line-height: ${iconSize}px;
        width: ${iconSize}px;
        min-width: ${iconSize}px;
        height: ${iconSize}px;
        color: ${settings.benefit_icon_color || "#000000"};
        margin-bottom: 4px;
      `;
      
      const icon = document.createElement("i");
      icon.className = iconClass;
      
      iconWrapper.appendChild(icon);
      contentDiv.appendChild(iconWrapper);
    }
    
    // Add heading text
    if (text) {
      const headingDiv = document.createElement("div");
      headingDiv.style.cssText = `
        margin: 0;
        color: ${settings.benefit_text_color || "#000000"};
        font-weight: 600;
      `;
      headingDiv.innerHTML = text;
      
      function applyHeadingSize() {
        const isMobile = window.innerWidth < 768;
        const baseFontSize = settings.text_font_size || 16;
        const fontSize = isMobile ? Math.round(baseFontSize * 0.875) : baseFontSize;
        
        headingDiv.style.fontSize = fontSize + "px";
        headingDiv.style.lineHeight = (fontSize + 4) + "px";
      }
      applyHeadingSize();
      window.addEventListener("resize", applyHeadingSize);
      
      contentDiv.appendChild(headingDiv);
    }
    
    // Add subtext
    if (subtext) {
      const subtextDiv = document.createElement("div");
      subtextDiv.style.cssText = `
        margin: 0;
        color: ${settings.subtext_color || "#6b7280"};
      `;
      subtextDiv.innerHTML = subtext;

      const applySubtextStyles = () => {
        const isMobile = window.innerWidth < 768;
        const baseFontSize = settings.subtext_font_size || 14;
        const fontSize = isMobile ? Math.round(baseFontSize * 0.875) : baseFontSize;
        
        subtextDiv.style.fontSize = fontSize + "px";
        subtextDiv.style.lineHeight = (fontSize + 4) + "px";
        
        // Apply to all child elements
        const children = subtextDiv.querySelectorAll("*");
        children.forEach(child => {
          child.style.fontSize = fontSize + "px";
          child.style.lineHeight = (fontSize + 4) + "px";
          child.style.color = settings.subtext_color || "#6b7280";
          child.style.margin = "0";
        });
      };
      applySubtextStyles();
      window.addEventListener("resize", applySubtextStyles);
      
      contentDiv.appendChild(subtextDiv);
    }
    
    boxDiv.appendChild(contentDiv);
    return boxDiv;
  }

  // Render all benefit boxes
  let hasContent = false;
  for (let i = 1; i <= 4; i++) {
    const box = createBenefitBox(i);
    if (box) {
      wrapper.appendChild(box);
      hasContent = true;
    }
  }
  
  if (hasContent) {
    component.appendChild(wrapper);
    console.log('Benefits rendered successfully with', wrapper.children.length, 'boxes');
  } else {
    console.warn('No benefit content found - check if benefit text fields are populated');
    component.style.display = "none";
  }
}

// Initialize on DOM ready
function initBenefits() {
  const components = document.querySelectorAll(".iconic-benefits-second-js");
  console.log('Found', components.length, 'benefit components');
  components.forEach(renderIconicBenefitsSecond);
}

// Handle both loading states
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initBenefits);
} else {
  initBenefits();
}

// Shopify theme editor events
const shopifyEvents = [
  "shopify:section:load",
  "shopify:section:select",
  "shopify:section:deselect",
  "shopify:section:reorder",
  "shopify:block:select",
  "shopify:block:deselect"
];

shopifyEvents.forEach(evt => {
  document.addEventListener(evt, (e) => {
    console.log(`Shopify event: ${evt}`);
    setTimeout(() => {
      const section = e.target;
      const blocks = section.querySelectorAll(".iconic-benefits-second-js");
      blocks.forEach(renderIconicBenefitsSecond);
    }, 100);
  });
});